import React, { ReactNode } from "react";
import { Container,Img } from "./styles";

import LogoSinsoft from "../../Assets/Sinsoft_Logo.png";
import { IconType } from "react-icons";
interface Params {
  children: ReactNode;
}
export function SignIn({ children }: Params) {
  return (
    <Container>
      <Img
      onClick={
        ()=>{
          window.open("http://www.sinsoft.com.br/")
        }
      }
        src={LogoSinsoft}
        style={{ width: "(8vw)", minWidth: "65px" }}
        alt="Logo Sinsoft Informática"
      />
      {children}
    </Container>
  );
}
